<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0"
    height="0"
    style="position: absolute; overflow: hidden"
    aria-hidden="true"
  >
    <defs>
      <!-- Surface gradient: letterpress dark face -->
      <linearGradient id="lp-surface" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stop-color="#2a2318" />
        <stop offset="100%" stop-color="#1e1a12" />
      </linearGradient>

      <!-- Inner highlight: subtle top glow -->
      <linearGradient id="lp-highlight" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stop-color="rgba(255,255,255,0.10)" />
        <stop offset="40%" stop-color="rgba(255,255,255,0)" />
      </linearGradient>

      <!-- Amber-tinted surface for warning icons -->
      <linearGradient id="lp-warning" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stop-color="#3a2a10" />
        <stop offset="100%" stop-color="#2a1e08" />
      </linearGradient>

      <!-- Red-tinted surface for danger icons -->
      <linearGradient id="lp-danger" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stop-color="#3a1010" />
        <stop offset="100%" stop-color="#2a0808" />
      </linearGradient>

      <!-- Base drop shadow filter -->
      <filter id="lp-shadow" x="-20%" y="-20%" width="140%" height="140%">
        <feDropShadow
          dx="0"
          dy="1"
          stdDeviation="1.5"
          flood-color="rgba(0,0,0,0.45)"
          flood-opacity="1"
        />
      </filter>

      <!-- Gold glow for trophy / celebration -->
      <filter id="lp-glow-gold" x="-40%" y="-40%" width="180%" height="180%">
        <feDropShadow
          dx="0"
          dy="0"
          stdDeviation="3"
          flood-color="rgba(201,168,76,0.6)"
          flood-opacity="1"
        />
      </filter>

      <!-- Green glow for success checkmark -->
      <filter id="lp-glow-success" x="-40%" y="-40%" width="180%" height="180%">
        <feDropShadow
          dx="0"
          dy="0"
          stdDeviation="3"
          flood-color="rgba(0,196,143,0.6)"
          flood-opacity="1"
        />
      </filter>

      <!-- Red glow for error X-circle -->
      <filter id="lp-glow-danger" x="-40%" y="-40%" width="180%" height="180%">
        <feDropShadow
          dx="0"
          dy="0"
          stdDeviation="3"
          flood-color="rgba(239,68,68,0.6)"
          flood-opacity="1"
        />
      </filter>
    </defs>
  </svg>
</template>
